import {ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {UserProfile} from '@shared/interfaces';
import {AuthState} from '@shared/state/auth/auth.state';
import {Select, Store} from '@ngxs/store';
import {Logout} from '@shared/state/auth/auth.actions';
import {takeUntil} from 'rxjs/operators';

@Component({
  selector: 'app-single-layout',
  templateUrl: './single-layout.component.html',
  styleUrls: ['./single-layout.component.scss']
})

export class SingleLayoutComponent implements OnInit, OnDestroy {
  @Select(AuthState.getUserData) user$: Observable<UserProfile>;
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  initials: any;
  user: any;

  constructor(private cd: ChangeDetectorRef, private store: Store) {
  }

  ngOnInit() {
    this.user$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(userData => {
        this.user = userData;
        this.initials = userData.name.split(' ').map((n) => n[0]).join('');
      });

    this.store.select(AuthState.getUserData)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((userData) => {
        if (userData) {
        }
      });
  }

  logout() {
    this.store.dispatch(new Logout());
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
